/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_SCENARIO_PRODUCTS_SUCCESS = 'GET_SCENARIO_PRODUCTS_SUCCESS'
export const GET_SCENARIO_PRODUCTS_FAILURE = 'GET_SCENARIO_PRODUCTS_FAILURE'

// -- CREATE
export const CREATE_SCENARIO_PRODUCT_SUCCESS = 'CREATE_SCENARIO_PRODUCT_SUCCESS'
export const CREATE_SCENARIO_PRODUCT_FAILURE = 'CREATE_SCENARIO_PRODUCT_FAILURE'

// -- UPDATE
export const UPDATE_SCENARIO_PRODUCT_SUCCESS = 'UPDATE_SCENARIO_PRODUCT_SUCCESS'
export const UPDATE_SCENARIO_PRODUCT_FAILURE = 'UPDATE_SCENARIO_PRODUCT_FAILURE'

// -- DELETE
export const DELETE_SCENARIO_PRODUCT_SUCCESS = 'DELETE_SCENARIO_PRODUCT_SUCCESS'
export const DELETE_SCENARIO_PRODUCT_FAILURE = 'DELETE_SCENARIO_PRODUCT_FAILURE'

// -- SEARCH
export const SEARCH_SCENARIO_PRODUCTS = 'SEARCH_SCENARIO_PRODUCTS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a project product attribute based on its name.
 *
 * @param {string} terms Text to be searched within the project product.
 * @returns {Promise<array<object>>}
 */
export const searchScenarioProducts = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_SCENARIO_PRODUCTS,
    data: terms
  })
}

/**
 * GET the list of product's attributes that belong to this scenario.
 *
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Array<object>}
 */
export const getScenarioProducts = (pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PRODUCT_LIST, { pid, sid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.getScenarioProducts()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_SCENARIO_PRODUCTS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_SCENARIO_PRODUCTS_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific scenario's product attribute.
 *
 * @param {object} newProduct New product scenario attribute object to be created.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Array<object>}
 */
export const createScenarioProduct = (newProduct, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PRODUCT_CREATE, { pid, sid })
  const api = new Api(path)
  const result = await api.create(newProduct)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.createScenarioProduct()', { path, newProduct, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_SCENARIO_PRODUCT_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_SCENARIO_PRODUCT_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific scenario product attribute.
 *
 * @param {object} newProduct New scenario's parameter attribute object that will replace the previous one.
 * @param {uuid} did Scenario's product ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const updateScenarioProduct = (newProduct, did, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PRODUCT_UPDATE, { pid, sid, did })
  const api = new Api(path)
  const result = await api.update(newProduct)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.updateScenarioProduct()', {
    path,
    newProduct,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_SCENARIO_PRODUCT_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_SCENARIO_PRODUCT_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific scenario product attribute.
 *
 * @param {uuid} did Scenario's product ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const deleteScenarioProduct = (did, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PRODUCT_DELETE, { pid, sid, did })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.deleteScenarioProduct()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_SCENARIO_PRODUCT_SUCCESS,
      data: did
    })
  }
  return dispatch({
    type: DELETE_SCENARIO_PRODUCT_FAILURE,
    data: result.data
  })
}
